import Services, { handleError } from "./index.service";
import Config from "../../config/config.js";
import { getSession, setSession, clearSession } from "@hooks/useSession";
import UserService from "./user.service.js";
import { sha256 } from "@/utils/crypto.js";

const { OshimedBackend, OshimedAPI } = Services;

/**
 * Service layer for authentication-related HTTP requests
 */
// -----------------------------------------------------------------------------
// POST /auth/login
// -----------------------------------------------------------------------------
const login = async (payload) => {
  try {
    const { email,hashedEmail, password, password2 } = payload;

    console.log("=== Config.API_URL === auth.service.js === key: 774782 ===");
    console.dir(Config.API_URL, { depth: null, colors: true });
    console.log("=================================");

    // Retrieve keys
    const tmpKeyRes = await getTmpApiKey(hashedEmail);
    if (tmpKeyRes?.success === false) {
      console.log("=== tmpKeyRes === auth.service.js === key: 500111 ===");
      console.dir(tmpKeyRes, { depth: null, colors: true });
      console.log("=================================");
      return tmpKeyRes;
    }
    const xApiKey = tmpKeyRes;

    console.log("=== xApiKey === auth.service.js === key: 809901 ===");
    console.dir(xApiKey, { depth: null, colors: true });
    console.log("=================================");

    const webhookTokenRes = await getWebhookToken(hashedEmail);
    if (webhookTokenRes?.success === false) {
      console.log(
        "=== webhookTokenRes === auth.service.js === key: 402256 ==="
      );
      console.dir(webhookTokenRes, { depth: null, colors: true });
      console.log("=================================");
      return webhookTokenRes;
    }
    const webhookToken = webhookTokenRes;

    console.log("=== webhookToken === auth.service.js === key: 809903 ===");
    console.dir(webhookToken, { depth: null, colors: true });
    console.log("=================================");

    // Build request body
    const body = {
      email:hashedEmail,
      password,
      webhook: {
        url: `${Config.BACKEND_URL}/auth/login`,
        method: "POST",
        params: {
          webhookToken,
          email:hashedEmail,
          password: password2,
        },
      },
    };

    console.log("=== body === auth.service.js === key: 564529 ===");
    console.dir(body, { depth: null, colors: true });
    console.log("=================================");

    const response = await OshimedAPI.post("/login", body, {
      headers: {
        "x-api-key": xApiKey,
      },
    });
    console.log("=== response.data === auth.service.js === key: 849644 ===");
    console.dir(response.data, { depth: null, colors: true });
    console.log("=================================");

    const loginResult = response.data;

    if (loginResult?.success===false) {
      await clearSession();
      return loginResult;
    }

    const user = {
      firstname: loginResult?.firstname,
      lastname: loginResult?.lastname,
      didAddress: loginResult?.didAddress,
      userId: loginResult.webhook?.response?.data.userId,
      email: payload.email,
      role: loginResult.webhook?.response?.data.role,
    }
  
  
    const sessionObject = {
      platformToken: loginResult.webhook?.response?.data.token,
      apiToken: loginResult.token,
      user,
    }

    setSession(sessionObject);


    return loginResult;
  } catch (error) {
    return handleError(error, 447491);
  }
};

// -----------------------------------------------------------------------------
// GET /auth/tmp-x-api-key/:hashed_email
// -----------------------------------------------------------------------------
const getTmpApiKey = async (hashedEmail) => {
  if (hashedEmail.includes("@")) {
    return {
      success: false,
      message: "Email not hashed",
      errorCode: "email-not-hashed",
      errorKey: 160474,
    };
  }
  try {
    const response = await OshimedBackend.get(
      `/auth/tmp-x-api-key/${hashedEmail}`
    );
    return response.data;
  } catch (error) {
    console.log("=== error === auth.service.js === key: 093883 ===");
    console.dir(error, { depth: null, colors: true });
    console.log("=================================");
    return handleError(error, 710157);
  }
};

// -----------------------------------------------------------------------------
// POST /signup
// -----------------------------------------------------------------------------
const signup = async (payload) => {

  console.log('=== payload === auth.service.js === key: 398483 ===');
  console.dir(payload, { depth: null, colors: true })
  console.log('=================================');

  try {
    const {
      emailClear, // clear e-mail
      email: hashedEmail, // hashed email
      password, // hashed password once
      password2, // double hash
      firstName,
      lastName,
      contactNumber,
      street,
      number,
      city,
      postalCode,
      country,
      role,
      study_id,
      site_id,
      investigator_id
    } = payload;

    // Retrieve temporary API key (requires hashed email)
    let tmpKeyRes = await getTmpApiKey(hashedEmail);
    if (tmpKeyRes?.success === false) return tmpKeyRes;
    const xApiKey = tmpKeyRes;

    // Build request body according to OshimedAPI spec
    const body = {
      email: emailClear,
      password, // already SHA-256 hashed once
      firstname: firstName,
      lastname: lastName,
      userProfile: "user",
      phone: contactNumber,
      postalAddress: `${street}, ${number}`,
      city,
      zipCode: postalCode,
      country,
      role,
      study_id,
      site_id,
      investigator_id,
    };

    const response = await OshimedAPI.post("/signup", body, {
      headers: {
        "x-api-key": xApiKey,
      },
    });
    

    const apiRes = response.data;
    console.log("=== OshimedAPI signup response === key: 567154 ===");
    console.dir(apiRes, { depth: null, colors: true });
    console.log("=================================");

    // If apiRes.success === false, propagate it
    if (
      apiRes?.success === false &&
      !apiRes?.errorCode === "user-already-exists"
    ) {
      return apiRes;
    }

    // 2) Register on platform backend ------------------------------------
    const didAddress = apiRes?.didAddress;
    if (!didAddress) {
      return {
        success: false,
        message: "Missing didAddress",
        errorCode: "signup-missing-did",
        errorKey: 214587,
      };
    }

    const apiToken = apiRes?.token;

    let participantId;
    
    if(role==="participant"){
      const joinStudyDelegateRes = await joinStudyDelegate({
        studyId:study_id,
        investigatorId:investigator_id,
        apiToken,
        email:emailClear,
      });
      console.log("=== joinStudyDelegateRes === auth.service.js === key: 801227 ===");
      console.dir(joinStudyDelegateRes, { depth: null, colors: true })
      console.log("=================================");
      participantId = joinStudyDelegateRes?.participantId;
    }

    // Get webhook token (tmp) using hashed email
    const webhookTokenRes = await getWebhookToken(hashedEmail);
    if (webhookTokenRes?.success === false) return webhookTokenRes;
    const webhookToken = webhookTokenRes;



    const platformBody = {
      email: emailClear,
      password: password2, // double-hashed password
      firstname: firstName,
      lastname: lastName,
      userProfile: "user",
      phone: contactNumber,
      postalAddress1: `${street}, ${number}`,
      postalAddress2: `${street}, ${number}`,
      city,
      zipCode: postalCode,
      country,
      didAddress,
      role,
      study_id,
      site_id,
      investigator_id,
      participant_id:participantId,
    };

    console.log('=== platformBody === auth.service.js === key: 689599 ===');
    console.dir(platformBody, { depth: null, colors: true })
    console.log('=================================');

    const backendRes = await OshimedBackend.post(
      "/auth/register",
      platformBody,
      {
        headers: {
          "x-webhook-token": webhookToken,
        },
      }
    );

    console.log("=== backendRes.data === auth.service.js === key: 735765 ===");
    console.dir(backendRes.data, { depth: null, colors: true });
    console.log("=================================");

    return backendRes.data;
  } catch (error) {
    console.log('=== error === auth.service.js === key: 125823 ===');
    console.dir(error, { depth: null, colors: true })
    console.log('=================================');
    return handleError(error, 125802);
  }
};

/**
 * Join a study as a delegate (participant).
 * @param {Object} params
 * @param {string} params.studyId - The study ID
 * @param {string} params.investigatorId - The investigator ID
 * @param {string} params.email - The participant email
 * @param {string} params.apiToken - The API token
 * @returns {Promise<Object>} The backend response
 */
const joinStudyDelegate = async ({ studyId, investigatorId,email, apiToken }) => {
  console.log(
    "=== {studyId, investigatorId} === auth.service.js === key: 774544 ==="
  );
  console.dir(
    { studyId, investigatorId,email, apiToken },
    { depth: null, colors: true }
  );
  console.log("=================================");

  if (!studyId || !investigatorId || !email || !apiToken) {
    const err = {
      success: false,
      message: "Missing mandatory fields: studyId or investigatorId or email or apiToken",
      errorCode: "missing-params",
      errorKey: 704583,
    };
    console.log('=== err === auth.service.js === key: 877205 ===');
    console.dir(err, { depth: null, colors: true })
    console.log('=================================');
    return err;
  }

  const hashedEmail = await sha256(email);
  const tmpKeyRes = await getTmpApiKey(hashedEmail);

  if (tmpKeyRes?.success === false) {
    console.error("V0_DEBUG: Missing xApiKey in session for joinCro.");
    return {
      success: false,
      message: "Missing xApiKey in session for joinCro.",
      errorCode: "join-cro-no-x-api-key",
      errorKey: 672676,
    };
  }
  const xApiKey = tmpKeyRes;

  try {
    const response = await OshimedAPI.patch(
      "/user/join-study-delegate",
      { studyId, investigatorReferalId: investigatorId },
      {
        headers: {
          "x-api-key": xApiKey,
          Authorization: `Bearer ${apiToken}`,
        },
      }
    );

    console.log("=== response === auth.service.js === key: 216773 ===");
    console.dir(response, { depth: null, colors: true });
    console.log("=================================");

    if (!response.data) {
      return {
        success: false,
        message: "Empty response",
        errorCode: "empty-response",
        errorKey: 499822,
      };
    }
    return response.data;
  } catch (error) {
    console.log("=== error === auth.service.js === key: 407055 ===");
    console.dir(error, { depth: null, colors: true });
    console.log("=================================");
    return handleError(error, 576788);
  }
};

// -----------------------------------------------------------------------------
// GET /webhook/token/:hashed_email
// -----------------------------------------------------------------------------
const getWebhookToken = async (hashedEmail) => {
  if (hashedEmail.includes("@")) {
    return {
      success: false,
      message: "Email not hashed",
      errorCode: "email-not-hashed",
      errorKey: 560942,
    };
  }
  try {
    const response = await OshimedBackend.get(`/webhook/token/${hashedEmail}`);
    console.log('=== response === auth.service.js === key: 269231 ===');
    console.dir(response, { depth: null, colors: true })
    console.log('=================================');
    return response.data;
  } catch (error) {
    console.log('=== error === auth.service.js === key: 184374 ===');
    console.dir(error, { depth: null, colors: true })
    console.log('=================================');
    return handleError(error, 828581);
  }
};



const getPresignedPayload = async (onDid, role, xApiKey) => {
  const session = getSession();
  try {
    const response = await OshimedAPI.get("/auth/delegate-token?on=" + onDid + "&role=" + role, {
      headers: {
        Authorization: `Bearer ${session?.apiToken}`,
        "x-api-key": xApiKey,
      },
    });
    return response.data;
  } catch (error) {
    console.log("=== error === auth.service.js === key: 504925 ===");
    console.dir(error, { depth: null, colors: true });
    console.log("=================================");
    return handleError(error, 504925);
  }
};

const isUserRegistered = async (hashedEmail) => {
  console.log('=== hashedEmail === auth.service.js === key: 483968 ===');
  console.dir(hashedEmail, { depth: null, colors: true })
  console.log('=================================');
  try {
    const response = await OshimedBackend.get(`/auth/is-user-registered/${hashedEmail}`);
    console.log('=== response.data === auth.service.js === key: 302696 ===');
    console.dir(response.data, { depth: null, colors: true })
    console.log('=================================');
    return response.data;
  } catch (error) {
    console.log("=== error === auth.service.js === key: 483969 ===");
    console.dir(error, { depth: null, colors: true });
    console.log("=================================");
    return handleError(error, 828581);
  }
};

export default {
  login,
  signup,
  getTmpApiKey,
  getWebhookToken,
  getPresignedPayload,
  isUserRegistered,
  joinStudyDelegate,
};
